import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import { KOSTENTRAEGER } from '../../../../../../../lib/constants/constant';
import SachkostenMA, { getFormStrucSachkostenMA } from './SachkostenMA';

// import schemas
import Schema from '../../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
const P = Schema.attributes;

export const GetSachkostenMA = (application: any, readOnly: boolean) => {
	const OrgaStruc = [
		{
			label: get(
				application,
				P.Foerderantrag.schema.attributes.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path,
				`Antragsteller`
			),
			content: <SachkostenMA kostentraeger={KOSTENTRAEGER.Antragsteller} unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
			formStruc: getFormStrucSachkostenMA(application, 'Antragsteller', get(getLocalstorageToken(), 'organisationId'), readOnly),
		},
	];
	const PartnerStruc = get(application, P.Foerderantrag.schema.attributes.Verbundpartner.path, []).map((ele: any, i: number) => {
		return {
			label: get(
				ele,
				P.Foerderantrag.schema.attributes.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					P.Foerderantrag.schema.attributes.Verbundpartner.path.length + 1
				),
				`Verbundpartner ${i + 1}`
			),
			content: <SachkostenMA kostentraeger={KOSTENTRAEGER.Verbundpartner} unternehmenId={get(ele, 'Verbundpartner.id')} />,
			formStruc: getFormStrucSachkostenMA(application, 'Verbundpartner', get(ele, 'Verbundpartner.id'), readOnly),
		};
	});

	return [...OrgaStruc, ...PartnerStruc];
};
